import type { AudioDeviceType } from './AudioDeviceProps'
import useActiveAudioDevice from './useActiveAudioDevice'
import useAudioDeviceStatus from './useAudioDeviceStatus'

export type AudioDevice = ReturnType<typeof useAudioDevice>

export default function useAudioDevice(
  deviceType: AudioDeviceType,
  devices: MediaDeviceInfo[],
) {
  const defaultDevice = { deviceId: 'SYSTEM', label: 'System' } as const
  const activeDevice = useActiveAudioDevice(deviceType) ?? devices[0] ?? defaultDevice
  const status = useAudioDeviceStatus(deviceType, devices)

  return {
    activeDevice,
    devices,
    status,
  }
}
